module.exports = __webpack_public_path__ + "static/img/stshopc.0a44e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stshopc.png
// module id = Z7LJ
// module chunks = 1